import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullScreenMediaComponent } from './full-screen-media.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [FullScreenMediaComponent],
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [
    FullScreenMediaComponent
  ]
})
export class FullScreenMediaModule { }
